<template>
  <pdf-a4-page no-margin :pdf-key="lang" v-for="(notizBlock, index) in splitIntoChunks(notizen)" :key="index">
    <div class="report-background w-screen h-screen">
      <page-header :ba="ba" :immobilie="immobilie" :Title="'Notizen'"/>
      <div class="flex flex-col justify-between">
        <div v-if="index === 0">
          <span class="pageHeader flex justify-between" style="margin-top: 5px;">Notizen des Bearbeiters</span>
          <hr class="trenner-m"/>
        </div>
        <div :class="[index === 0  ? 'content' : 'content-long']">
          <div class="title-container">
            <span v-if="notizBlock?.[0] == null && index == 0" class="smallHeader pt-10">Es sind keine Notizen vorhanden</span>
            <div v-else v-for="(notiz, index2) in notizBlock" :key="index2">
              <div v-if="notiz != null" class="fragenBlock">
                <div class="smallHeader" data-cy="note-title">
                {{ "Notiz " + (index * 3 + 1 + index2) + " - " + notiz.fragenblocks?.[0].frages?.[0].eingabeText }}
                </div>
                <div class="textBlock" v-if="notiz?.fragenblocks?.[0].frages?.[2].eingabeText !== ''" data-cy="note-description">
                  {{ notiz.fragenblocks?.[0].frages?.[2].eingabeText }}
                </div>
                <div class="textBlock mt-2" v-else>
                  {{ "Keine Beschreibung vorhanden" }}
                </div>
                <div class="mt-5 flex">
                  <div class="ml-2 mr-2 mt-3">Fotos:</div>
                  <div class="mt-0" data-cy="pdf-note-photos" v-if="notiz?.fragenblocks?.[0].frages?.[3].eingabeMedien?.[0] != null">
                    <PdfImageRow :imageObjects="getImageObjects(notiz, 3)"/>
                  </div> 
                  <div class="mt-3" data-cy="pdf-note-photos" v-else>
                    Keine Fotos
                  </div>          
                </div>
                <hr class="trenner" v-if="index2 != notizBlock.length - 1"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <page-bottom/>
    </div>
  </pdf-a4-page>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue';
  import { Fragenblock } from '@/models/ba/Fragenblock';
  import PdfA4Page from '@/components/Pdf/Components/PdfA4Page.vue';
  import PageHeader from './PageHeader.vue';
  import Immobilie from "../../../models/immobilie.model";
  import Bestandsaufnahme from '@/models/ba/Bestandsaufnahme';
  import PdfImageRow from './NewVationImageRow.vue';
  import PageBottom from './PageBottom.vue';

  export default defineComponent({
    name: 'ReportPage',
    components: {
      PdfA4Page,
      PageHeader,
      PdfImageRow,
      PageBottom,
    },
    props: {
      notizen: {
        type: Array as PropType<Fragenblock[]>,
        required: true,
      },
      lang: {
        type: String,
        default: 'de',
      },
      ba: {
        type: Object as PropType<Bestandsaufnahme>,
        required: true,
      },
      immobilie: {
        type: Object as PropType<Immobilie>,
        required: true,
      }
    },
    methods: {
      getImageObjects(notiz: any, index: number) {
        return notiz?.fragenblocks?.[0].frages?.[index].eingabeMedien ?? [];
      },
      splitIntoChunks(notizen: any[]) {
        notizen = notizen.slice(1, notizen.length);
        const result = [];
        for (let i = 0; i < notizen.length; i += 3)
            result.push(notizen.slice(i, i + 3));
        return result;
      }
    },
    data() {
      return {
        index: 0,
      };
    },
  });
</script>

<style scoped lang="scss">
  * {
    color: black;
    background-color: white;
    font-size: 12px;
  }
  .pdf-content {
    width: 800px;
    margin: 0 auto;
    color: var(--white100);
    height: 1100px;
  }
  .report-background {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 700px;
    height: 1050px;
    color: var(--black100);
    margin-bottom: -20px;
  }
  .pageHeader {
    font-weight: bold;
    font-size: 20px;
    margin-top: -45px;
  }
  .midHeader {
    font-weight: bold;
    font-size: 15px;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 5px;
  }
  .smallHeader {
    font-weight: bold;
    font-size: 12px;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-left: 10px;
  }
  .content {
    height: 830px;
  }
  .content-long {
    height: 895px; 
  }
  .stackpanel {
    display: flex;
    flex-direction: row;
  }
  .textBlock {
    margin-left: 20px;
    margin-right: 20px;
  }
  .trenner {
    position: sticky;
    border: none;
    height: 1px;
    color: black;
    background: black;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 5px;
    margin-right: 5px;
    width: 690px;
  }
  .trenner-l {
    @extend .trenner;
    height: 2px !important;
    margin-left: -20px !important;
    margin-right: -20px !important;
    width: 740px;
  }
  .trenner-m {
    @extend .trenner;
    height: 1.5px !important;
    margin-left: -10px !important;
    margin-right: -10px !important;
    width: 720px;
  }
  .icon {
    margin-right: 20px;
    display: flex;
    padding-top: -20px;
  }
  img {
    border-radius: 5px;
  }
  .fragenBlock {
    height: auto;
    max-height: 240px;
    overflow: hidden;
  }
</style>
